import Image from "next/image";

const ApplyButton = ({disable, handleClick}) => {
    const data = {
        disableBtn: {
            img: '/img/apply-btn-disable@3x.webp',
            width: 201,
            height: 61
        },
        enableBtn: {
            img: '/img/apply-btn-enable@3x.webp',
            width: 201,
            height: 61
        }
    }
    
    if (disable) {
            return (
                <div className="flex items-center justify-center">
                    <div className="w-[70%] md:w-auto">
                        <Image src={data.disableBtn.img} width={data.disableBtn.width} height={data.disableBtn.height} layout="intrinsic" />
                    </div>
                </div>
            )
    } else {
        return (
            <button onClick={handleClick}>
                <div className="flex items-center justify-center">
                    <div className="w-[70%] md:w-auto">
                        <Image src={data.enableBtn.img} width={data.enableBtn.width} height={data.enableBtn.height} layout="intrinsic" />
                    </div>
                </div>
            </button>
        )
    }
};

export default ApplyButton;
